import { map, reduce } from 'lodash'
import { filterDisabledOperatingHours } from './revenueCenters/filterDisabledOperatingHours'

export const extendMenusByHoursValues = (allMenus, menuSettings) => {
  return reduce(
    allMenus,
    (res, cur, index) => {
      const changedMenu = map(
        menuSettings,
        (menuSetting, menuSettingIndex) => {
          if (index === menuSettingIndex) {
            return {
              ...cur,
              operatingHours: filterDisabledOperatingHours(
                menuSetting?.operatingHours
              ),
              orderAheadHours: menuSetting?.orderAheadHours,
              preorder: menuSetting?.preorder,
              merchantId: menuSetting?.merchantId
            }
          } else {
            return null
          }
        }
      )

      const uniqChangedMenu = [...res, ...changedMenu].filter(
        (menu) => menu !== null
      )
      return uniqChangedMenu
    },
    []
  )
}
